import React from 'react';
import './Legal.css';

function PrivacyPolicy() {
    return (
        <div className="legal-page">
            <div className="container">
                <h1>سياسة الخصوصية</h1>
                <p>نحن في خدمات صحتك نولي أهمية كبرى لخصوصية بياناتك...</p>
                <h2>1. المعلومات التي نجمعها</h2>
                <p>نقوم بجمع المعلومات التي تقدمها لنا مباشرة عند التسجيل...</p>
                <h2>2. كيف نستخدم معلوماتك</h2>
                <p>نستخدم المعلومات لتحسين خدماتنا وتوفير تجربة أفضل...</p>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
